import { NavigationActions } from "@/components/navigation/ducks/slice"
import {
  ADD_USER_AFFINITY,
  ADD_USER_RELATIONSHIP,
  CLAIM_ZOOM_PROFILE,
  CREATE_DEGREE,
  CREATE_POSITION,
  DELETE_ALL_USER_EXPERIENCES,
  DELETE_CLAIMED_ZOOM_PROFILE,
  DELETE_DEGREE,
  DELETE_POSITION,
  DELETE_USER_AFFINITY,
  DELETE_USER_RELATIONSHIP,
  FETCH_AFFINITY_SUGGESTIONS,
  FETCH_INDUSTRY_SUGGESTIONS,
  INVITE_TO_ZOOM,
  RECEIVE_UPDATE_USER,
  receiveAffinitySuggestions,
  receiveIndustrySuggestions,
  receiveUpdateUser,
  receiveUpdateUserConstituent,
  SAVE_AVATAR,
  toggleEditProfileOff,
  UPDATE_CURRENT_USER,
  UPDATE_DEGREE,
  UPDATE_POSITION,
} from "@/components/profile/ducks/Actions"
import {
  addUserAffinity,
  addUserRelationship,
  apiClaimZoomProfile,
  apiDeleteClaimedZoomProfile,
  apideleteAllUserExperiences,
  apiFetchAffinitySuggestions,
  apiFetchIndustrySuggestions,
  apiInviteToZoom,
  createDegree,
  createPosition,
  deleteDegree,
  deletePosition,
  deleteUserAffinity,
  deleteUserRelationship,
  saveAvatar,
  updateCurrentUser,
  updateDegree,
  updatePosition,
} from "@/components/profile/ducks/AJAX"
import { refetchSearch } from "@/components/search/ducks/Actions"

export default (store) => (next) => (originalAction) => {
  const action = originalAction
  const { dispatch } = store

  const receiveFetchIndustrySuggestionsSuccess = (response) => {
    dispatch(receiveIndustrySuggestions(response.industries))
  }

  const receiveUpdateUserSuccess = (cb) => (response) => {
    const { currentUser } = response

    dispatch(receiveUpdateUser(currentUser))
    if (cb) {
      cb()
    }
  }

  const receiveEditGroupRelationshipSuccess = (cb) => (response) => {
    const { currentConstituent } = response

    dispatch(receiveUpdateUserConstituent(currentConstituent))
    dispatch(refetchSearch())
    if (cb) {
      cb()
    }
  }

  const receiveUpdateCurrentUserSuccess = (cb) => (response) => {
    const { currentUser, currentConstituent } = response

    dispatch(receiveUpdateUserConstituent(currentConstituent))
    dispatch(receiveUpdateUser(currentUser))
    if (cb) {
      cb()
    }
  }

  const receiveFetchAffinitySuggestionsSuccess = (response) => {
    dispatch(receiveAffinitySuggestions(response.affinitySuggestions))
  }

  switch (action.type) {
    case RECEIVE_UPDATE_USER:
      dispatch(refetchSearch())
      return next(action)

    case UPDATE_CURRENT_USER:
      updateCurrentUser(
        action.currentUser,
        receiveUpdateCurrentUserSuccess(action.success),
        action.error,
      )
      return next(action)

    case UPDATE_POSITION:
      updatePosition(action.position, receiveUpdateUserSuccess(action.success), action.error)
      return next(action)

    case DELETE_POSITION:
      deletePosition(action.position, receiveUpdateUserSuccess(), action.error)
      return next(action)

    case CREATE_POSITION:
      createPosition(action.position, receiveUpdateUserSuccess(action.success), action.error)
      return next(action)

    case UPDATE_DEGREE:
      updateDegree(action.degree, receiveUpdateUserSuccess(action.success), action.error)
      return next(action)

    case DELETE_DEGREE:
      deleteDegree(action.degree, receiveUpdateUserSuccess(), action.error)
      return next(action)

    case CREATE_DEGREE:
      createDegree(action.degree, receiveUpdateUserSuccess(action.success), action.error)
      return next(action)

    case ADD_USER_AFFINITY:
      addUserAffinity(
        action.affinity,
        receiveEditGroupRelationshipSuccess(action.success),
        action.error,
      )
      return next(action)

    case DELETE_USER_AFFINITY:
      deleteUserAffinity(action.affinityId, receiveEditGroupRelationshipSuccess(), action.error)
      return next(action)

    case ADD_USER_RELATIONSHIP:
      addUserRelationship(
        action.relationship,
        receiveEditGroupRelationshipSuccess(action.success),
        action.error,
      )
      return next(action)

    case DELETE_USER_RELATIONSHIP:
      deleteUserRelationship(
        action.relationshipId,
        receiveEditGroupRelationshipSuccess(action.success),
        action.error,
      )
      return next(action)

    case SAVE_AVATAR:
      saveAvatar(action.img, receiveUpdateUserSuccess(action.success), action.error)
      return next(action)

    case FETCH_AFFINITY_SUGGESTIONS:
      apiFetchAffinitySuggestions(action.query, receiveFetchAffinitySuggestionsSuccess)
      return next(action)

    case DELETE_ALL_USER_EXPERIENCES:
      apideleteAllUserExperiences(
        action.experienceType,
        receiveUpdateUserSuccess(action.success),
        action.error,
      )
      return next(action)

    case CLAIM_ZOOM_PROFILE:
      apiClaimZoomProfile(receiveUpdateUserSuccess(action.success), action.error)
      return next(action)

    case DELETE_CLAIMED_ZOOM_PROFILE:
      apiDeleteClaimedZoomProfile(receiveUpdateUserSuccess(action.success), action.error)
      return next(action)

    case FETCH_INDUSTRY_SUGGESTIONS:
      apiFetchIndustrySuggestions(action.query, receiveFetchIndustrySuggestionsSuccess)
      return next(action)

    case INVITE_TO_ZOOM:
      apiInviteToZoom(action.params, action.success, action.error)
      return next(action)

    case NavigationActions.clearSuffixLink.fulfilled.type: {
      dispatch(toggleEditProfileOff())
      return next(action)
    }

    default:
      return next(action)
  }
}
